import React, { useState } from 'react';
import { Avatar, Box, Button, Typography } from '@mui/material';
import DealOptionsMenu from '../../DealOptionsMenu';
import { GamifyIcon } from '../../../../components/GamifyIcon';

export default function DealKanbanCard(props: any) {
  const {
    deal,
    selectedDealId,
    handleDealSelection,
    setAddDealOpen,
    handleOpenOwnerDealStageModal,
    onTriggerDealsRefetch,
    userId,
    searchStage,
    dealType,
    dealTypesCategoryIdMap,
    dealTypesConfigMap,
    dealFilter,
    categoryId,
    searchString,
    fromDealPage,
    setIsLoaded,
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (e: any) => {
    setAnchorEl(e.currentTarget);
    setAddDealOpen(false);
    // setSortOpen(false);
  };

  return (
    <Box
      style={{
        width: 450,
        backgroundColor: 'white',
        padding: 8,
        marginBottom: 12,
        borderRadius: 8,
        border:
          deal.id === selectedDealId
            ? '1px solid #FF6A00'
            : '1px solid #D0D2D8',
      }}
      sx={{ cursor: 'pointer' }}
      onClick={(e) => handleDealSelection(e, deal.id, deal)}
    >
      <Box className={'deal-card-name-stage-section'}>
        <Typography className={'deal-card-full-name-text'}>
          {deal.name}
        </Typography>
        <Box className={'deal-card-name-stage-section-right'}>
          {/* NOTE: Add deal options menu back in once deals are fetched with new lambda */}
          {/* Only admin, closer, or setter should be able to view deal options */}
          {/* @ts-ignore */}
          {(global.me.isAdmin ||
            // @ts-ignore
            global.me.id === setter?.id ||
            // @ts-ignore
            global.me.id === closer?.id) && (
            <>
              <Button
                disableRipple={true}
                // onClick={handleDealOptionsClick}
                onClick={(e) => handleMenuOpen(e)}
                className={'ellipsis-button'}
              >
                <GamifyIcon
                  icon={'ellipsis'}
                  color={'white'}
                  backgroundColor={''}
                  width={17}
                  height={4}
                />
              </Button>
              <DealOptionsMenu
                props={{
                  anchorEl,
                  setAnchorEl,
                  handleOpenOwnerDealStageModal,
                  onTriggerDealsRefetch,
                  userId,
                  searchStage,
                  dealType,
                  dealTypesCategoryIdMap,
                  dealTypesConfigMap,
                  dealFilter,
                  categoryId,
                  searchString,
                  fromDealPage,
                  setIsLoaded,
                  ourDeal: deal,
                  setter: deal.setter,
                  closer: deal.closer,
                }}
              ></DealOptionsMenu>
            </>
          )}
        </Box>
      </Box>
      {deal.attrs?.length > 0 ? (
        // @ts-ignore
        deal.attrs.map((attr, i) => (
          <Box key={i}>
            <Typography className={'deal-card-attribute-text'}>
              {attr}
            </Typography>
          </Box>
        ))
      ) : (
        <></>
      )}
      <Box className={'deal-card-owner-section'}>
        <Box className={'deal-card-owner-section-left'}>
          <Box style={{ display: 'flex' }}>
            <Typography
              style={{
                fontSize: '14px',
                fontWeight: 500,
                marginRight: 4,
              }}
            >
              Setter:
            </Typography>
            {deal.setter?.profilePicture ? (
              <Avatar
                className={'deal-card-owner-profile-picture'}
                src={deal.setter?.profilePicture}
              />
            ) : (
              <Avatar className={'deal-card-owner-profile-picture'}>
                <Typography style={{ fontSize: 12, fontWeight: 600 }}>
                  {deal.setter?.initials}
                </Typography>
              </Avatar>
            )}
            <Typography className={'deal-card-owner-text'}>
              {deal.setter?.name}
            </Typography>
          </Box>
          <Box style={{ display: 'flex', marginTop: 12 }}>
            <Typography
              style={{
                fontSize: '14px',
                fontWeight: 500,
                marginRight: 4,
              }}
            >
              Closer:
            </Typography>
            {deal.closer ? (
              deal.closer.profilePicture ? (
                <Avatar
                  className={'deal-card-owner-profile-picture'}
                  src={deal.closer.profilePicture}
                />
              ) : (
                <Avatar className={'deal-card-owner-profile-picture'}>
                  <Typography style={{ fontSize: 12, fontWeight: 600 }}>
                    {deal.closer.initials}
                  </Typography>
                </Avatar>
              )
            ) : (
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#bdbdbd',
                  width: 24,
                  height: 24,
                  borderRadius: 1000,
                  marginRight: 8,
                }}
              >
                <GamifyIcon
                  icon={'user'}
                  color={'#323232'}
                  backgroundColor={''}
                  width={'14'}
                  height={'16'}
                ></GamifyIcon>
              </Box>
            )}
            <Typography className={'deal-card-owner-text'}>
              {deal.closer ? deal.closer.name : 'Unassigned'}
            </Typography>
          </Box>
        </Box>
        <Box className={'deal-card-owner-section-right'}>
          <Typography className="deal-card-updated-at-text">
            {deal.updatedAt}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
